"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.rejectSuperProposal = exports.createSafeTransaction = exports.getNextNonce = void 0;
var ethers_1 = require("ethers");
var transaction_service_1 = require("./transaction-service");
var utils_1 = require("../utils");
/**
 * Gets the nonce of the next transaction for a safe
 * @param safeAddress - safe address
 * @returns Nonce of next transaction
 */
function getNextNonce(safeAddress) {
    return __awaiter(this, void 0, void 0, function () {
        var txs, nonce;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, transaction_service_1.getSafeTransactionsBySafe)(safeAddress, { limit: 1 })];
                case 1:
                    txs = _a.sent();
                    nonce = txs.length === 0 ? 0 : txs[0].nonce + 1;
                    return [2 /*return*/, nonce];
            }
        });
    });
}
exports.getNextNonce = getNextNonce;
/**
 * Creates safe transaction
 * @param input.safe - Address of Gnosis safe
 * @param input.to - Smart contract address (i.e., MemberToken)
 * @param input.value - Value to send
 * @param input.data - Transaction data
 * @param input.sender - Address that is initiating the transaction
 * @returns {SafeTransaction}
 */
function createSafeTransaction(input) {
    return __awaiter(this, void 0, void 0, function () {
        var safeTxGas, err_1, _a, nonce, threshold, data, safeTxHash, createdSafeTransaction;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, transaction_service_1.getGasEstimation)(input)];
                case 1:
                    safeTxGas = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _b.sent();
                    if (err_1.response.data.arguments[0])
                        throw new Error(err_1.response.data.arguments[0]);
                    throw err_1;
                case 3: return [4 /*yield*/, (0, transaction_service_1.getSafeInfo)(input.safe)];
                case 4:
                    _a = _b.sent(), nonce = _a.nonce, threshold = _a.threshold;
                    data = {
                        safe: input.safe,
                        to: ethers_1.ethers.utils.getAddress(input.to),
                        value: input.value || '0',
                        data: input.data || ethers_1.ethers.constants.HashZero,
                        sender: ethers_1.ethers.utils.getAddress(input.sender),
                        confirmationsRequired: threshold,
                        safeTxGas: safeTxGas,
                        // If provided an override nonce
                        nonce: input.nonce ? input.nonce : nonce,
                        operation: 0,
                        baseGas: 0,
                        gasPrice: '0'
                    };
                    return [4 /*yield*/, (0, transaction_service_1.getSafeTxHash)(data)];
                case 5:
                    safeTxHash = _b.sent();
                    return [4 /*yield*/, (0, transaction_service_1.submitSafeTransactionToService)(__assign({ safeTxHash: safeTxHash }, data))];
                case 6:
                    createdSafeTransaction = _b.sent();
                    return [2 /*return*/, createdSafeTransaction];
            }
        });
    });
}
exports.createSafeTransaction = createSafeTransaction;
/**
 * Rejects a super proposal
 *
 * Super proposal rejections, from the sub proposal point of view, are separate approveHash calls that approve
 * a rejection transaction on the super pod
 *
 * @param superProposalTxHash - The transaction hash that identifies the original super proposal (i.e., not the rejection super proposal)
 * @param subProposal - The sub proposal related to the superProposalTxHash
 * @param signer - Signer of sub pod member
 */
function rejectSuperProposal(superProposalTxHash, subPod, signer) {
    return __awaiter(this, void 0, void 0, function () {
        var superProposal, superPodTransactions, superReject, signerAddress, subPodProposals, subReject, err_2, subApprove, subRejectTransaction, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, transaction_service_1.getSafeTransactionByHash)(superProposalTxHash)];
                case 1:
                    superProposal = _c.sent();
                    return [4 /*yield*/, (0, transaction_service_1.getSafeTransactionsBySafe)(superProposal.safe, {
                            nonce: superProposal.nonce
                        })];
                case 2:
                    superPodTransactions = _c.sent();
                    superReject = superPodTransactions.find(function (safeTx) { return safeTx.data === null && safeTx.to === superProposal.safe; });
                    if (!!superReject) return [3 /*break*/, 4];
                    return [4 /*yield*/, (0, transaction_service_1.createRejectTransaction)(superProposal, subPod.safe)];
                case 3:
                    // No such tx, we have to create ourselves. This is a standard Gnosis reject
                    // This will not sign the transaction because we're just passing the pod safe.
                    superReject = _c.sent();
                    _c.label = 4;
                case 4: return [4 /*yield*/, signer.getAddress()];
                case 5:
                    signerAddress = _c.sent();
                    return [4 /*yield*/, subPod.getProposals({ status: 'queued', limit: 10 })];
                case 6:
                    subPodProposals = _c.sent();
                    subReject = subPodProposals.find(function (proposal) {
                        return proposal.method === 'approveHash' &&
                            // Looking for an approveHash that is NOT for the super proposal we have, that should be the reject
                            // TODO: This theoretically fails if there are two unrelated super proposals being voted on simultaneously.
                            proposal.parameters[0].value !== superProposal.safeTxHash &&
                            proposal.status !== ('passed' || 'rejected');
                    });
                    if (!subReject) return [3 /*break*/, 10];
                    if (subReject.approvals.includes(signerAddress))
                        throw new Error('Signer already approved sub proposal');
                    _c.label = 7;
                case 7:
                    _c.trys.push([7, 9, , 10]);
                    // Approve the existing sub proposal
                    return [4 /*yield*/, (0, transaction_service_1.approveSafeTransaction)(subReject.safeTransaction, signer)];
                case 8:
                    // Approve the existing sub proposal
                    _c.sent();
                    return [2 /*return*/];
                case 9:
                    err_2 = _c.sent();
                    throw new Error("Error when approving sub proposal: ".concat(err_2));
                case 10:
                    subApprove = subPodProposals.find(function (proposal) {
                        return proposal.method === 'approveHash' &&
                            // Looking for an approveHash that is NOT for the super proposal we have, that should be the reject
                            // TODO: This theoretically fails if there are two unrelated super proposals being voted on simultaneously.
                            proposal.parameters[0].value === superProposal.safeTxHash &&
                            proposal.status !== ('passed' || 'rejected');
                    });
                    _a = createSafeTransaction;
                    _b = {
                        safe: subPod.safe,
                        to: superProposal.safe,
                        data: (0, utils_1.encodeFunctionData)('GnosisSafe', 'approveHash', [superReject.safeTxHash])
                    };
                    return [4 /*yield*/, signer.getAddress()];
                case 11: return [4 /*yield*/, _a.apply(void 0, [(_b.sender = _c.sent(),
                            // If the sub approve exists, use the same nonce. Otherwise createSafeTransaction will auto-populate
                            // the appropriate nonce if we pass null.
                            _b.nonce = subApprove ? subApprove.id : null,
                            _b)])];
                case 12:
                    subRejectTransaction = _c.sent();
                    return [4 /*yield*/, (0, transaction_service_1.approveSafeTransaction)(subRejectTransaction, signer)];
                case 13:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.rejectSuperProposal = rejectSuperProposal;
